import { Object3D } from 'three';

export class OpenPoseBodyNode {
  /*
   * FIELDS
   */

  name: string;
  object: Object3D;

  /*
   * METHODS
   */

  constructor(name: string, object: Object3D) {
    this.name = name;
    this.object = object;
  }
}
